module.exports = __webpack_public_path__ + "static/img/hover-iocn63.04bb3a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn63.png
// module id = hgso
// module chunks = 3